import { Link } from "react-router-dom";
import "../../styles/Footer/Footer.css";
import { PAGINAS_LEGALES } from "../PoliticayPrivacidad/datosTitular";
import LogoPlato from "../Comun/LogoPlato";

const Footer = () => {
  return (
    <footer className="footer_nav">
      <div className="footer_interior">
        <p className="footer_marca">
          <LogoPlato tamano={24} className="footer_logo" />
          <span>Plato tras Plato</span>
        </p>

        <nav className="footer_enlaces" aria-label="Pie de página">
          <ul className="footer_list">
            <li>
              <Link className="footer_list_element" to="/">
                Inicio
              </Link>
            </li>
            <li>
              <Link className="footer_list_element" to="/recipes">
                Recetas
              </Link>
            </li>
            <li>
              <Link className="footer_list_element" to="/contacto">
                Contacto
              </Link>
            </li>
          </ul>
        </nav>

        <nav className="footer_legal" aria-label="Información legal">
          <ul className="footer_list footer_list--legal">
            {PAGINAS_LEGALES.map((p) => (
              <li key={p.ruta}>
                <Link className="footer_list_element" to={p.ruta}>
                  {p.titulo}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <p className="footer_text">©2026 Desarrollado por Santiago Correa </p>
    </footer>
  );
};

export default Footer;
